import styled from "styled-components";

export const StyledFooter = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  height: 200px;
  padding: 8px;
  border-top: 1px solid #ccc;
`;
